<template>
  <el-dialog
    v-model="dialogVisible"
    title="人员详情"
    width="70%"
    @close="closeDialog"
  >
    <template v-if="showDetile">
      <div class="personDetailDialog">
        <div class="first-content" v-if="dataInfo">
          <div class="left-card">
            <div
              class="left-card-top"
              @mouseover="mouseInImg"
              @mouseout="mouseOutImg"
              @mousemove="mouseMoveImg"
            >
              <img class="imgStyle" :src="dataInfo.imageUrl" />
              <div class="shadowimg"></div>
              <div class="bigimg">
                <img class="bigDetialStyle" :src="dataInfo.imageUrl" />
              </div>
            </div>
            <div class="left-card-bottom">
              <div class="Title">关联操作</div>
              <div class="left-card-bottom-content">
                <el-button
                  type="primary"
                  @click="downImgFile(dataInfo.imageUrl)"
                  >图片下载</el-button
                >
                <el-button type="primary" @click="videoBack"
                  >录像回放</el-button
                >
              </div>
            </div>
          </div>
          <el-card class="tabs-card">
            <div class="tabsCard-content-left">
              <div class="one">
                <div class="Title">抓拍信息</div>
                <el-row>
                  <el-col class="leftTitle" :span="7"> 设备ID:</el-col>
                  <el-col :span="17">{{
                    dataInfo.deviceId ? dataInfo.deviceId : "--"
                  }}</el-col>
                </el-row>
                <el-row>
                  <el-col class="leftTitle" :span="7">抓拍时间:</el-col>
                  <el-col :span="17">{{
                    moment(parseInt(dataInfo.snapTime)).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}</el-col></el-row
                >
                <el-row>
                  <el-col class="leftTitle" :span="7">抓拍地点:</el-col>
                  <el-col :span="17">{{
                    dataInfo.deviceName ? dataInfo.deviceName : "--"
                  }}</el-col></el-row
                >

                <el-row>
                  <el-col class="leftTitle" :span="7">戴帽子:</el-col>
                  <el-col :span="17">{{
                    !dataInfo.cap ? "--" : dataInfo.cap == "0" ? "否" : "是"
                  }}</el-col></el-row
                >
                <el-row>
                  <el-col class="leftTitle" :span="7">戴眼镜:</el-col>
                  <el-col :span="17">{{
                    !dataInfo.glasses
                      ? "--"
                      : dataInfo.glasses == "0"
                      ? "否"
                      : "是"
                  }}</el-col></el-row
                >
              </div>
              <div class="one">
                <div class="Title">识别信息</div>
                <el-row>
                  <el-col class="leftTitle" :span="5">姓名:</el-col>
                  <el-col :span="12"
                    ><span>{{
                      dataInfo.prisonName ? dataInfo.prisonName : "--"
                    }}</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    class="leftTitle"
                    :span="5"
                    :title="dataInfo.prisonCardNumber"
                    >身份证号:</el-col
                  >
                  <el-col :span="12">{{
                    dataInfo.prisonCardNumber ? dataInfo.prisonCardNumber : "--"
                  }}</el-col>
                </el-row>
                <el-row>
                  <el-col class="leftTitle" :span="5">性别:</el-col>
                  <el-col :span="12" v-if="dataInfo.gender">{{
                    dataInfo.gender == 1 ? "男" : "女"
                  }}</el-col>
                  <el-col :span="12" v-else>{{ "--" }}</el-col>
                </el-row>
                <el-row>
                  <el-col class="leftTitle" :span="5">年龄段:</el-col>
                  <el-col :span="12">{{
                    dataInfo.ageUpLimit && dataInfo.ageLowerLimit
                      ? dataInfo.ageUpLimit + "--" + dataInfo.ageLowerLimit
                      : "--"
                  }}</el-col>
                </el-row>
                <el-row>
                  <el-col class="leftTitle" :span="5">相似度:</el-col>
                  <el-col :span="12">{{
                    dataInfo.faceSimilarity
                      ? dataInfo.faceSimilarity + "%"
                      : "--"
                  }}</el-col>
                </el-row>
                <el-row>
                  <el-col class="leftTitle" :span="5">常住人口:</el-col>
                  <el-col :span="12">{{
                    dataInfo.prisonName ? "是" : "否"
                  }}</el-col>
                </el-row>
              </div>
            </div>
            <div class="tabsCard-content-right">
              <div class="mapInfo">
                <MyMap ref="mapRef" />
              </div>
            </div>
          </el-card>
          <h-video-dialog
            v-if="videoDialogData && showVideoDialog"
            v-model:visible="showVideoDialog"
            :videoData="videoDialogData"
            :title="videoTitle"
            :zIndex="2100"
          ></h-video-dialog>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  nextTick,
  watchEffect,
  onMounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import { addrTrans } from "@/api/smartApplication/personSearchApi.js";
import { propRetrievalDetail } from "@/api/publicSecurityResearch/keyKehicles.js";
import { ElMessageBox, ElMessage } from "element-plus";
import moment from "moment";
import util from "@util/js";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "personDetailDialog",
  components: { MyMap },
  props: {
    tableParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    itemInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["closeDetial", "update:visible"],
  setup(props, { emit }) {
    const router = useRouter();
    const data = reactive({
      showDetile: true,
      box: null,
      shadow: null,
      bigimg: null,
      dialogVisible: false,
      dataInfo: null,
      showVideoDialog: false,
      videoDialogData: null,
      videoTitle: "",
    });
    const tableRef = ref(null);
    const refData = toRefs(data);
    const mapRef = ref();

    //使用wache监听不报红
    watchEffect(() => {
      data.dialogVisible = props.visible;
    });
    watchEffect(() => {
      data.dataInfo = props.itemInfo;
      nextTick(() => {
        tollgateRecordAsync();
      });
    });
    const closeDialog = () => {
      emit("closeDetial");
      emit("update:visible", false);
    };
    //图片放大
    const mouseInImg = () => {
      data.box = document.querySelector(".left-card-top");
      data.shadow = document.querySelector(".shadowimg");
      data.bigimg = document.querySelector(".bigimg");
      data.big = document.querySelector(".bigDetialStyle");
      data.shadow.style.display = "block";
      data.big.style.display = "block";
    };
    const mouseOutImg = () => {
      data.shadow.style.display = "none";
      data.big.style.display = "none";
    };
    const mouseMoveImg = (e) => {
      let x = e.pageX - data.box.offsetLeft - 300;
      let y = e.pageY - data.box.offsetTop - 190;
      let width = x - data.shadow.offsetWidth / 2;
      let height = y - data.shadow.offsetHeight / 2;
      if (width <= 0) {
        width = 0;
      } else if (width >= data.box.offsetWidth - data.shadow.offsetWidth) {
        width = data.box.offsetWidth - data.shadow.offsetWidth;
      }
      if (height <= 0) {
        height = 0;
      } else if (height >= data.box.offsetHeight - data.shadow.offsetHeight) {
        height = data.box.offsetHeight - data.shadow.offsetHeight;
      }
      data.shadow.style.left = width + 20 + "px";
      data.shadow.style.top = height + 20 + "px";
      let big = document.querySelector(".bigDetialStyle");
      let bigx =
        (width * (big.offsetWidth - data.bigimg.offsetWidth)) /
        (data.box.offsetWidth - data.shadow.offsetWidth);
      let bigy =
        (height * (big.offsetHeight - data.bigimg.offsetHeight)) /
        (data.box.offsetHeight - data.shadow.offsetHeight);
      big.style.left = -bigx + "px";
      big.style.top = -bigy + "px";
    };

    const changeCpn = () => {
      data.showDetile = !data.showDetile;
    };
    const urlToBase64 = async (url) => {
      const path = {
        paths: [url],
      };
      const res = await addrTrans(path);
      data.dataInfo.base64Url = res.data[0];
    };
    //获取过人详情
    const tollgateRecordAsync = async () => {
      // const params = {
      //   beginTime: props.tableParams.beginTime,
      //   endTime: props.tableParams.endTime,
      //   motorVehicleId: props.itemInfo.motorVehicleId,
      // };
      // const res = await propRetrievalDetail(params, {
      //   loading: true,
      //   loadingDom: ".personDetailDialog",
      // });
      // data.dataInfo = res.data;
      nextTick(() => {
        setTimeout(() => {
          // urlToBase64(data.dataInfo.vehicleUrl);
          pointInfoArray();
        });
      });
    };
    //添加接口中数据点位
    const pointInfoArray = () => {
      let pointInfo = {
        name: "",
        id: 1,
        type: 1,
        poiType: 3408,
        location: [],
        click: (e) => {},
      };
      pointInfo.location[0] = parseFloat(data.dataInfo.longitude);
      pointInfo.location[1] = parseFloat(data.dataInfo.latitude);
      console.log(pointInfo.location);
      nextTick(() => {
        mapRef.value && mapRef.value.loadMarker([pointInfo]);
        mapRef.value && mapRef.value.mapLocation(pointInfo.location, 12);
      });
    };
    //图片下载
    const downImgFile = (url) => {
      // const url = "/imgApi/?" + data.dataInfo.base64Url.split("/?")[1];
      util.downImgFile(url);
    };
    // 视频回放
    const videoBack = () => {
      data.showVideoDialog = true;
      data.videoTitle = "视频回放";
      data.videoDialogData = data.dataInfo;
    };

    return {
      ...refData,
      mapRef,
      tableRef,
      moment,
      mouseInImg,
      mouseOutImg,
      mouseMoveImg,
      changeCpn,
      closeDialog,
      downImgFile,
      videoBack,
    };
  },
});
</script>
<style lang="scss" scoped>
.personDetailDialog {
  width: 100%;
  height: 65vh;
  position: relative;

  .first-content {
    width: 100%;
    height: 100%;
    display: flex;
    .Title {
      border-left: 3px solid #5584ff;
      font-size: 14px;
      color: #333;
      font-weight: bolder;
      height: 20px;
      line-height: 20px;
      padding-left: 8px;
      margin: 15px 0;
    }
    .left-card {
      width: 100%;
      height: 100%;
      width: 550px;
      padding: 20px;
      @include flex-col-c-s;
      /deep/.el-card__body {
        width: 100%;
      }
      .left-card-top {
        width: 100%;
        height: 70%;
        .imgStyle {
          width: 100%;
          height: 100%;
        }
        .shadowimg {
          position: absolute;
          top: 0;
          left: 0;
          height: 100px;
          width: 100px;
          background: #333;
          opacity: 0.7;
          border: 1px solid #333;
          display: none;
        }
        .bigimg {
          padding: 10px;
          height: 40%;
          width: 23%;
          overflow: hidden;
          margin-left: 10px;
          position: relative;
          position: absolute;
          left: 535px;
          top: 73px;
          z-index: 5;
          pointer-events: none;
          .bigDetialStyle {
            display: none;
            width: 500%;
            height: 500%;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
      .left-card-bottom {
        margin: 24px 0;
        .left-card-bottom-content {
          margin: 25px 10px;
          @include flex-row-s-e;
          flex-wrap: wrap;
          .el-button {
            margin: 15px;
          }
        }
      }
    }
  }

  .tabs-card {
    flex: 1;
    margin-left: 10px;
    /deep/ .el-card__body {
      display: flex;
      flex-direction: row !important;
      flex-wrap: wrap;
    }

    .el-row {
      margin: 8px 0 8px 16px;
    }
    .tabsCard-content-left {
      width: 100%;
      height: 35%;
      display: flex;
      flex-wrap: wrap;
      .one {
        width: 50%;
      }
    }
    .tabsCard-content-right {
      width: 100%;
      height: calc(65% - 20px);
      .mapInfo {
        border: 1px solid #fff;
        width: 100%;
        height: 100%;
        margin-top: 20px;
      }
    }
  }
}
.carArchivesDialog {
  height: 65vh;
}
.icon {
  position: absolute;
  top: 50%;
  color: #fff;
  cursor: pointer;
  &.you {
    right: -50px;
  }
  &.zuo {
    left: -50px;
  }
}
</style>
